import { Box, Text } from '@chakra-ui/react';

import { KybDocumentType } from '__generated__/GQL';
import asBentoPage from 'common/bento/hoc/asBentoPage';
import Heading from 'components/_core/Heading';
import SunshineCard from 'components/_core/SunshineCard';
import SunshineIcon from 'components/_core/SunshineIcon';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import { getUploadKybFunction } from 'features/Storage/upload';

import FileUpload from '../../../../../../components/_core/FileUpload';
import { FILE_SIZE } from '../../../../legacy/components/TreezorUpload';
import { KybDocumentFile, ProofOfFundsDocumentType } from '../../machine/model';
import { locales } from './locales';

const getRulesBySelectedOption: Record<ProofOfFundsDocumentType, string[]> = {
  [ProofOfFundsDocumentType.bankStatement]: [locales.rules.lessThanThreeMonths],
  [ProofOfFundsDocumentType.loanCertificate]: [
    locales.rules.lessThanThreeMonths,
  ],
  [ProofOfFundsDocumentType.paySlip]: [
    locales.rules.mostRecent,
    locales.rules.superiorToContribution,
  ],
};

interface ProofOfFundsUploadProps {
  onUploadComplete: (documentFile: KybDocumentFile) => void;
  companyProfileId: string;
  selectedOption: ProofOfFundsDocumentType;
}

const ProofOfFundsUpload = asBentoPage<ProofOfFundsUploadProps>(
  ({ companyProfileId, Layout, onPrev, onUploadComplete, selectedOption }) => {
    return (
      <Layout
        data-testid="company-papers-upload"
        nav={<OBNavigation onPrev={onPrev} />}
      >
        <Box>
          <Heading marginBottom="space-32" size="lg">
            {`${locales.title} ${locales.types[selectedOption]}`}
          </Heading>

          <FileUpload
            maxByteSizeParam={FILE_SIZE.SUPPORTING_DOCUMENTS}
            onSuccessfulUpload={async ({ bucketName, fileRef, url }) =>
              onUploadComplete({
                firebaseBucket: bucketName,
                firebaseRef: fileRef,
                type: KybDocumentType.ProofOfFunds,
                url,
              })
            }
            uploadFile={getUploadKybFunction(companyProfileId)}
          />

          <Text marginTop="space-32">{locales.rules.title}</Text>
          {getRulesBySelectedOption[selectedOption].map((rule) => (
            <SunshineCard
              alignItems="center"
              isBoxed={false}
              key={rule}
              marginTop="space-24"
            >
              <SunshineCard.Slot name="aside">
                <SunshineIcon color="primary" name="tick" />
              </SunshineCard.Slot>

              <SunshineCard.Content>
                <SunshineCard.Title color="primary">{rule}</SunshineCard.Title>
              </SunshineCard.Content>
            </SunshineCard>
          ))}
        </Box>
      </Layout>
    );
  },
);

export default ProofOfFundsUpload;
